export const TimeZoneActionTypes = {
    SET_TIME_ZONE: "SET_TIME_ZONE",
}